const basicAuthLookup = {
  '@sonderborg.dk': 'https://logout@sso.sonderborg.dk/adfs/ls/wia?client-request-id=0',
};

function getBasicAuthLogoutUrl(email) {
  console.log('email: ', email);
  if (email) {
    const emailEnding = `@${email.split('@')[1]}`;
    return basicAuthLookup[emailEnding];
  }
  return null;
}

// eslint-disable-next-line import/prefer-default-export
export { getBasicAuthLogoutUrl };
